import { allScheduleStatusType } from "@/components/customs/BadgeScheduleStatus";

/** Matches schedules/page.tsx: p-6, white card, status pills, responsive grid */
export default function SchedulesListPageSkeleton() {
  return (
    <div className="skeleton-stage p-6 w-full" aria-busy aria-label="Loading">
      <div className="flex flex-col gap-6 bg-white rounded-xl p-6">
        <div className="flex space-x-2 overflow-x-auto pb-1">
          {allScheduleStatusType.map((tab) => (
            <div
              key={tab}
              className="h-9 min-w-[88px] rounded-full skeleton-shimmer shrink-0"
            />
          ))}
        </div>

        <div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div
              key={i}
              className="border rounded-lg p-4 bg-white relative"
            >
              <div className="flex items-center gap-x-2 mb-3">
                <div className="h-3 w-24 skeleton-shimmer rounded" />
                <div className="ml-auto h-6 w-16 rounded-full skeleton-shimmer" />
              </div>
              <div className="flex items-center mb-4">
                <div className="skeleton-shimmer rounded-lg p-3 flex flex-col items-center justify-center mr-3 w-[52px] h-[68px]">
                  <div className="h-6 w-6 skeleton-shimmer rounded mb-1 opacity-80" />
                  <div className="h-3 w-8 skeleton-shimmer rounded opacity-80" />
                </div>
                <div className="flex flex-col gap-2 flex-1 min-w-0">
                  <div className="h-4 w-[180px] max-w-full skeleton-shimmer rounded" />
                  <div className="h-3 w-[120px] max-w-full skeleton-shimmer rounded" />
                </div>
              </div>
              <div className="flex gap-2 justify-end">
                <div className="h-8 w-20 rounded-md skeleton-shimmer" />
                <div className="h-8 w-20 rounded-md skeleton-shimmer" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
